import { supabase } from './supabaseClient';

// Sign Up
export const signUp = async (email: string, password: string, gender: string) => {
  try {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: { gender },
      },
    });
    if (error) return { user: null, error };

    // Store auth state if needed
    localStorage.setItem("userToken", "authenticated");
    localStorage.setItem("userEmail", email);
    localStorage.setItem("userGender", gender);
    
    // Return the full user object (which contains the UID in data.user.id)
    return { user: data.user, error: null };
  } catch (error: any) {
    return { user: null, error: { message: error.message || "Failed to sign up" } };
  }
};

// Sign In
export const signIn = async (email: string, password: string) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) {
      return { user: null, error };
    }
    
    // Store authentication state and user metadata
    localStorage.setItem('userToken', 'authenticated');
    localStorage.setItem('userEmail', email);
    // Assuming your user metadata contains gender
    const gender = data.user?.user_metadata?.gender || 'male';
    localStorage.setItem('userGender', gender);
    
    return { user: data.user, error: null };
  } catch (error: any) {
    return { user: null, error: { message: error.message || "Failed to sign in" } };
  }
};

// Sign Out
export const signOut = async () => {
  // Clear authentication state
  localStorage.removeItem('userToken');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userGender');
  
  return { error: null };
};

// Add this function to your existing auth.ts file
export const checkAuth = async (): Promise<boolean> => {
  // Simple check for token in localStorage
  const userToken = localStorage.getItem('userToken');
  return !!userToken;
};

/**
 * Trigger a password reset email for the given address.
 *
 * @param email The user's email address.
 * @returns An object with the data or error from the request.
 */
export async function forgotPassword(email: string) {
  const { data, error } = await supabase.auth.resetPasswordForEmail(email);
  return { data, error };
}
